import { useMemo } from 'react'

import { columnKey, useGrid } from '@Components/Grid/context'
import { PinnedColumnsProvider as BasePinnedColumnsProvider } from '@Components/tableResize/pinned'

export { usePinnedColumns, usePinnedHeaderCell, pinnedCellProps } from '@Components/tableResize/pinned'

export function PinnedColumnsProvider({ children }) {
  const { visibleColumns, pinnedColumns } = useGrid()

  const pinnedIndexes = useMemo(
    () => (visibleColumns || []).reduce((indexes, column, index) => pinnedColumns.includes(columnKey(column)) ? [...indexes, index] : indexes, []),
    [visibleColumns, pinnedColumns],
  )

  return <BasePinnedColumnsProvider pinnedIndexes={pinnedIndexes} columns={visibleColumns}>
    {children}
  </BasePinnedColumnsProvider>
}
